import {IMessage, IRuleset} from "../../../../index";

type TTranslationKeyPrefix = `${'permission'}.${'add'|'delete'|'update'}.${'system'|'systemrole'}`
type TTranslationKey = `${TTranslationKeyPrefix}.${string}`


interface IResultObject {
    data: IRuleset | IMessage | null
    error: KnockoutObservable<string | null>
    icon: KnockoutObservable<string | null>
    label: KnockoutObservable<string | null>
    link: KnockoutObservable<string | null>
    objIcon: string | null
    spinner: KnockoutObservable<boolean>
}
